export default __webpack_public_path__ + "static/media/freck.f55a5850.png";